import { taskFilters } from 'settings/constants/transactionTasks';

export const prepareFiltersWithTransactionTask = (
  taskStatusFilter,
  loggedInUserID,
  allFilters = {},
) => {
  const filters = { ...allFilters };

  switch (taskStatusFilter) {
    case taskFilters.myTasks:
      filters['assignee'] = 'me';
      break;
    case taskFilters.tasksIAssigned:
      filters['assignedByIds'] = [loggedInUserID];
      break;
    case taskFilters.clientTasks:
      filters['isClientTask'] = true;
      break;
    case taskFilters.collaboratorTasks:
      filters['isCollaboratorTask'] = true;
      break;
    case taskFilters.teamTasks:
      filters['isTeamTask'] = true;
      break;
    case taskFilters.campaignOnly:
      filters['campaignOnly'] = true;
      break;
  }

  return filters;
};
